import gatheringJson from './gathering.json'
import chocoboDiggingJson from './chocoboDigging.json'
import type { GatherRecord, GatheringData } from '@/types'

export const gatheringData: GatheringData = gatheringJson as GatheringData
export const allRecords: GatherRecord[] = [
  ...gatheringData.records,
  ...(chocoboDiggingJson as GatheringData).records,
]
